
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jpMnG", function(module, exports) {

$parcel$export(module.exports, "MediaInlineImageCard", () => $f34f4663ccb261f9$export$fca833ae4278270f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $4FhhO = parcelRequire("4FhhO");

var $hlhtG = parcelRequire("hlhtG");
var $js7oX = parcelRequire("js7oX");

var $inPa6 = parcelRequire("inPa6");

var $dehRH = parcelRequire("dehRH");
var $ihjDz = parcelRequire("ihjDz");

var $fO7zn = parcelRequire("fO7zn");

var $3rvSa = parcelRequire("3rvSa");

var $7NoXb = parcelRequire("7NoXb");

var $iu6m9 = parcelRequire("iu6m9");

var $cys8a = parcelRequire("cys8a");

var $5gVJx = parcelRequire("5gVJx");

var $gPGX6 = parcelRequire("gPGX6");

var $37aQC = parcelRequire("37aQC");

var $gNaJv = parcelRequire("gNaJv");

var $7WU7p = parcelRequire("7WU7p");
const $f34f4663ccb261f9$export$5d2cd1bea8591ba3 = ({ mediaClient: mediaClient, identifier: identifier, isSelected: isSelected, intl: intl, alt: alt, isLazy: isLazy, width: width, height: height, border: border, ssr: ssr, serializeDataAttrs: serializeDataAttrs, shouldOpenMediaViewer: shouldOpenMediaViewer, isViewOnly: isViewOnly })=>{
    const [fileState, setFileState] = (0, $gwFzn.useState)();
    const [subscribeError, setSubscribeError] = (0, $gwFzn.useState)();
    const [isFailedEventSent, setIsFailedEventSent] = (0, $gwFzn.useState)(false);
    const [isSucceededEventSent, setIsSucceededEventSent] = (0, $gwFzn.useState)(false);
    const [isMediaViewerVisible, setMediaViewerVisible] = (0, $gwFzn.useState)(false);
    const { formatMessage: formatMessage } = intl || (0, $hlhtG.createIntl)({
        locale: 'en'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireFailedOperationalEvent = (error = new (0, $ihjDz.MediaCardError)('missing-error-data'), failReason)=>{
        if (!isFailedEventSent && fileState) {
            setIsFailedEventSent(true);
            (0, $dehRH.fireFailedOperationalEvent)(fileState, error, failReason, createAnalyticsEvent);
        }
    };
    const fireSucceededOperationalEvent = ()=>{
        if (!isSucceededEventSent && fileState) {
            setIsSucceededEventSent(true);
            (0, $dehRH.fireSucceededOperationalEvent)(fileState, createAnalyticsEvent);
        }
    };
    (0, $gwFzn.useEffect)(()=>{
        if (mediaClient) {
            const subscription = mediaClient.file.getFileState(identifier.id, {
                collectionName: identifier.collectionName
            }).subscribe({
                next: (fileState)=>{
                    setFileState(fileState);
                    setSubscribeError(undefined);
                },
                error: (e)=>{
                    setSubscribeError(e);
                }
            });
            return ()=>{
                subscription.unsubscribe();
            };
        }
    }, [
        identifier,
        mediaClient
    ]);
    const content = (dimensions)=>{
        if (!mediaClient) return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $7WU7p.InlineImageCardLoadingView), null);
        if (!ssr) {
            if (subscribeError) {
                const isUploading = fileState?.status === 'uploading';
                const errorMessage = isUploading ? (0, $cys8a.messages).failedToUpload : (0, $cys8a.messages).unableToLoadContent;
                const errorReason = fileState?.status === 'uploading' ? 'upload' : 'metadata-fetch';
                fireFailedOperationalEvent(new (0, $ihjDz.MediaCardError)(errorReason, subscribeError));
                return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gNaJv.InlineImageCardErrorView), {
                    message: formatMessage(errorMessage)
                });
            }
            if (!fileState || fileState?.status === 'uploading') return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $7WU7p.InlineImageCardLoadingView), null);
            if (fileState.status === 'error') {
                fireFailedOperationalEvent(new (0, $ihjDz.MediaCardError)('error-file-state', new Error(fileState.message)));
                return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gNaJv.InlineImageCardErrorView), {
                    message: formatMessage((0, $cys8a.messages).unableToLoadContent)
                });
            } else if (fileState.status === 'failed-processing') {
                fireFailedOperationalEvent(undefined, 'failed-processing');
                return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gNaJv.InlineImageCardErrorView), {
                    message: formatMessage((0, $cys8a.messages).unableToLoadContent)
                });
            } else if (!fileState.name) {
                fireFailedOperationalEvent(new (0, $ihjDz.MediaCardError)('metadata-fetch', new (0, $fO7zn.FileFetcherError)('emptyFileName', {
                    id: fileState.id
                })));
                return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gNaJv.InlineImageCardErrorView), {
                    message: formatMessage((0, $cys8a.messages).unableToLoadContent)
                });
            }
            if (fileState.status === 'processed') fireSucceededOperationalEvent();
        }
        return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3rvSa.MediaClientContext).Provider, {
            value: mediaClient
        }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gPGX6.InlineImageCard), {
            dimensions: dimensions,
            identifier: identifier,
            renderError: ()=>/*#__PURE__*/ (0, $3jLHL.jsx)((0, $gNaJv.InlineImageCardErrorView), {
                    message: formatMessage((0, $cys8a.messages).unableToLoadContent)
                }),
            alt: alt,
            ssr: ssr?.mode,
            isLazy: isLazy,
            crop: true,
            stretch: false
        }));
    };
    const aspectRatio = (0, $gwFzn.useMemo)(()=>width && height ? width / height : undefined, [
        width,
        height
    ]);
    /**
   * scaledDimensions is used to define the correct media size fetched from media service
   * inline images will only ever be rendered at a maximum height of H1 and so scaled dimensions
   * will only ever return a width and height where the height has a maximum height of H1
   */ const scaledDimension = (0, $gwFzn.useMemo)(()=>{
        if (!width || !height || !aspectRatio) return {
            width: width,
            height: height
        };
        return {
            width: Math.round(aspectRatio * (0, $5gVJx.referenceHeights)['h1']),
            height: (0, $5gVJx.referenceHeights)['h1']
        };
    }, [
        width,
        height,
        aspectRatio
    ]);
    const htmlAttributes = (0, $gwFzn.useMemo)(()=>{
        if (serializeDataAttrs) {
            const resolvedAttrs = fileState && fileState.status !== 'error' ? {
                'data-file-size': fileState.size,
                'data-file-mime-type': fileState.mimeType,
                'data-file-name': fileState.name
            } : {};
            return {
                'data-type': 'image',
                'data-node-type': 'mediaInline',
                'data-id': identifier.id,
                'data-collection': identifier.collectionName,
                'data-width': width,
                'data-height': height,
                'data-alt': alt,
                ...resolvedAttrs
            };
        }
        return {};
    }, [
        alt,
        fileState,
        height,
        identifier,
        width,
        serializeDataAttrs
    ]);
    const onMediaInlineImageClick = (0, $gwFzn.useCallback)((e)=>{
        if (shouldOpenMediaViewer) setMediaViewerVisible(true);
        // In edit mode (node content wrapper has contenteditable set to true), link redirection is disabled by default
        // We need to call "stopPropagation" here in order to prevent in editor view mode, the browser from navigating to
        // another URL if the media node is wrapped in a link mark.
        if (isViewOnly && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) e.preventDefault();
    }, [
        shouldOpenMediaViewer,
        isViewOnly
    ]);
    const onMediaInlinePreviewClose = (0, $gwFzn.useCallback)(()=>{
        setMediaViewerVisible(false);
    }, []);
    const mediaViewer = (0, $gwFzn.useMemo)(()=>{
        if (isMediaViewerVisible && mediaClient?.mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4FhhO))).createPortal(/*#__PURE__*/ (0, $3jLHL.jsx)((0, $7NoXb.default), {
            collectionName: identifier.collectionName || '',
            items: [
                identifier
            ],
            mediaClientConfig: mediaClient?.mediaClientConfig,
            selectedItem: identifier,
            onClose: onMediaInlinePreviewClose
        }), document.body);
        return null;
    }, [
        identifier,
        isMediaViewerVisible,
        mediaClient?.mediaClientConfig,
        onMediaInlinePreviewClose
    ]);
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $37aQC.InlineImageWrapper), {
        isSelected: isSelected,
        aspectRatio: aspectRatio,
        borderColor: border?.borderColor,
        borderSize: border?.borderSize,
        htmlAttrs: htmlAttributes,
        onClick: onMediaInlineImageClick
    }, content(scaledDimension)), mediaViewer);
};
const $f34f4663ccb261f9$export$fca833ae4278270f = (0, $js7oX.default)($f34f4663ccb261f9$export$5d2cd1bea8591ba3, {
    enforceContext: false
});

});
parcelRegister("dehRH", function(module, exports) {

$parcel$export(module.exports, "getSucceededStatusPayload", () => $fc1f7121f2c54ee5$export$95e48cf5f4b392a4);
$parcel$export(module.exports, "getErrorStatusPayload", () => $fc1f7121f2c54ee5$export$b37f976ad373d2e0);
$parcel$export(module.exports, "getFailedProcessingStatusPayload", () => $fc1f7121f2c54ee5$export$d0b5daf3b6a26055);
$parcel$export(module.exports, "fireFailedOperationalEvent", () => $fc1f7121f2c54ee5$export$d66a74eca3334206);
$parcel$export(module.exports, "fireSucceededOperationalEvent", () => $fc1f7121f2c54ee5$export$3bc90882cb04fda4);

var $bhuzI = parcelRequire("bhuzI");

var $ihjDz = parcelRequire("ihjDz");
const $fc1f7121f2c54ee5$export$95e48cf5f4b392a4 = (fileState)=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'success',
            fileAttributes: {
                fileId: fileState?.id || '',
                fileSize: fileState?.size,
                fileMediatype: fileState?.mediaType,
                fileMimetype: fileState?.mimeType,
                fileStatus: fileState?.status
            }
        }
    };
};
const $fc1f7121f2c54ee5$export$b37f976ad373d2e0 = (fileId, error, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            ...(0, $bhuzI.extractErrorInfo)(error)
        }
    };
};
const $fc1f7121f2c54ee5$export$d0b5daf3b6a26055 = (fileId, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            failReason: 'failed-processing'
        }
    };
};
const $fc1f7121f2c54ee5$export$d66a74eca3334206 = (fileState, error = new (0, $ihjDz.MediaCardError)('missing-error-data'), failReason, createAnalyticsEvent)=>{
    const payload = failReason ? $fc1f7121f2c54ee5$export$d0b5daf3b6a26055(fileState?.id || 'unknown-id', fileState) : $fc1f7121f2c54ee5$export$b37f976ad373d2e0(fileState?.id || 'unknown-id', error, fileState);
    (0, $bhuzI.fireMediaCardEvent)(payload, createAnalyticsEvent);
};
const $fc1f7121f2c54ee5$export$3bc90882cb04fda4 = (fileState, createAnalyticsEvent)=>{
    const payload = $fc1f7121f2c54ee5$export$95e48cf5f4b392a4(fileState);
    (0, $bhuzI.fireMediaCardEvent)(payload, createAnalyticsEvent);
};

});

parcelRegister("cys8a", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d94a223ed3433d0e$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $d94a223ed3433d0e$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    unableToLoadContent: {
        id: "fabric.editor.unableToLoadContent",
        defaultMessage: "We couldn't load this content"
    },
    failedToUpload: {
        id: "fabric.editor.failed_to_upload",
        defaultMessage: "Failed to upload"
    }
});

});

parcelRegister("gPGX6", function(module, exports) {

$parcel$export(module.exports, "InlineImageCard", () => $c12bc8babb02df83$export$bb1dd14451154199);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $fCrf0 = parcelRequire("fCrf0");

var $k0QVR = parcelRequire("k0QVR");

var $aWYXa = parcelRequire("aWYXa");

var $7WU7p = parcelRequire("7WU7p");
const $c12bc8babb02df83$export$bb1dd14451154199 = ({ dimensions: dimensions, identifier: identifier, renderError: renderError, alt: alt, isLazy: isLazy, ssr: ssr, crop: crop, stretch: stretch })=>{
    // Generate unique traceId for file
    const traceContext = (0, $gwFzn.useMemo)(()=>({
            traceId: (0, $fCrf0.getRandomHex)(8)
        }), []);
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO do we need to handle nonCriticalError
    const { preview: preview, error: previewError, onImageError: onImageError, onImageLoad: onImageLoad, getSsrScriptProps: getSsrScriptProps, copyNodeRef: copyNodeRef } = (0, $k0QVR.useFilePreview)({
        identifier: identifier,
        ssr: ssr,
        dimensions: dimensions,
        traceContext: traceContext
    });
    if (previewError) return renderError({
        error: previewError
    });
    if (!preview) return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $7WU7p.InlineImageCardLoadingView), null);
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $aWYXa.MediaImage), {
        dataURI: preview.dataURI,
        alt: alt,
        previewOrientation: preview.orientation,
        onImageLoad: ()=>{
            onImageLoad(preview);
        },
        onImageError: onImageError,
        loading: isLazy ? 'lazy' : undefined,
        forceSyncDisplay: !!ssr,
        crop: crop,
        stretch: stretch,
        ref: copyNodeRef
    }), getSsrScriptProps && /*#__PURE__*/ (0, $3jLHL.jsx)("script", getSsrScriptProps()));
};

});
parcelRegister("7WU7p", function(module, exports) {

$parcel$export(module.exports, "InlineImageCardLoadingView", () => $59ac8d14dbcf9d7f$export$4b1a62d8f05056a7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $9hlns = parcelRequire("9hlns");

var $88T0B = parcelRequire("88T0B");

var $2UgCw = parcelRequire("2UgCw");
const $59ac8d14dbcf9d7f$export$4b1a62d8f05056a7 = ({ testId: testId = 'media-inline-image-card-loading-view', height: height = (0, $88T0B.ICON_SIZE_THRESOLD) })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $2UgCw.Frame), {
        testId: testId
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $9hlns.default), {
        size: height > (0, $88T0B.ICON_SIZE_THRESOLD) ? 'medium' : 'small',
        interactionName: "media-inline-spinner"
    }));
};

});
parcelRegister("88T0B", function(module, exports) {

$parcel$export(module.exports, "ICON_SIZE_THRESOLD", () => $6a98a0a47ebe23af$export$88e3664eef60c981);
/** Height threshold that determines icon size to be small or medium */ const $6a98a0a47ebe23af$export$88e3664eef60c981 = 24;

});

parcelRegister("2UgCw", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $365414ee34d9fe7e$export$b89a827e9254211a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $9CJBf = parcelRequire("9CJBf");
const $365414ee34d9fe7e$export$b89a827e9254211a = ({ children: children, testId: testId })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: (0, $9CJBf.wrapperStyle),
        "data-testid": testId
    }, children);

});
parcelRegister("9CJBf", function(module, exports) {

$parcel$export(module.exports, "wrapperStyle", () => $0090dcbf00152f3e$export$c4d4f06a25de97f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");
const $0090dcbf00152f3e$export$c4d4f06a25de97f = (0, $3jLHL.css)({
    display: 'inline-flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    boxDecorationBreak: 'clone',
    borderRadius: `${"var(--ds-border-radius, 3px)"}`,
    color: `${"var(--ds-text, #172B4D)"}`,
    backgroundColor: `${"var(--ds-background-neutral, #091E420F)"}`,
    transition: '0.1s all ease-in-out',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: `${"var(--ds-background-neutral-hovered, #091E4224)"}`
    }
});

});




parcelRegister("37aQC", function(module, exports) {

$parcel$export(module.exports, "InlineImageWrapper", () => $7cf4b05323c49fee$export$8519fee8cc913056);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $bSKDV = parcelRequire("bSKDV");

var $fhm10 = parcelRequire("fhm10");
// The MediaImage component needs to obtain its parent's dimensions.
// To achieve this, we have added an additional wrapper that allows
// for better interaction with the parent element. This is necessary
//  because the parent size changes its box-sizing with the node border.
const $7cf4b05323c49fee$var$sizeWrapperStyle = (0, $3jLHL.css)({
    display: 'inline-flex',
    width: '100%',
    height: '100%'
});
const $7cf4b05323c49fee$export$8519fee8cc913056 = ({ children: children, isSelected: isSelected, aspectRatio: aspectRatio, borderSize: borderSize, borderColor: borderColor, htmlAttrs: htmlAttrs = {}, onClick: onClick })=>{
    const borderStyleVars = borderSize && borderColor ? {
        [(0, $fhm10.INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY)]: borderSize,
        [(0, $fhm10.INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY)]: (0, $bSKDV.hexToEditorBorderPaletteColor)(borderColor) || borderColor
    } : {};
    const aspectStyleVars = aspectRatio ? {
        [(0, $fhm10.INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY)]: aspectRatio
    } : {};
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...borderStyleVars,
            ...aspectStyleVars
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $fhm10.wrapperStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            borderSize && borderColor && (0, $fhm10.borderStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isSelected && (0, $fhm10.selectedStyle)
        ],
        "data-testid": "inline-image-wrapper",
        onClick: onClick,
        ...htmlAttrs
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: $7cf4b05323c49fee$var$sizeWrapperStyle
    }, children)));
};

});

parcelRegister("gNaJv", function(module, exports) {

$parcel$export(module.exports, "InlineImageCardErrorView", () => $d55d56648ffb705b$export$cbdc50f98f4f8d00);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $6hqEj = parcelRequire("6hqEj");

var $3gadb = parcelRequire("3gadb");

var $88T0B = parcelRequire("88T0B");

var $2UgCw = parcelRequire("2UgCw");

var $cUGgR = parcelRequire("cUGgR");
const $d55d56648ffb705b$export$cbdc50f98f4f8d00 = ({ testId: testId = 'media-inline-image-card-error-view', message: message, icon: icon, height: height = (0, $88T0B.ICON_SIZE_THRESOLD) })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $2UgCw.Frame), {
        testId: testId
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3gadb.default), {
        content: message,
        position: "top",
        tag: "span",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $cUGgR.IconWrapper), null, icon || /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6hqEj))), {
        label: "error",
        LEGACY_size: height > (0, $88T0B.ICON_SIZE_THRESOLD) ? 'medium' : 'small',
        color: "var(--ds-icon-danger, #C9372C)"
    }))));
};

});
parcelRegister("cUGgR", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $6ea526080872ea45$export$be58b4326e23250f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");
const $6ea526080872ea45$var$wrapperStyle = (0, $3jLHL.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    'span > svg': {
        verticalAlign: 'top'
    }
});
const $6ea526080872ea45$export$be58b4326e23250f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: $6ea526080872ea45$var$wrapperStyle,
        "data-testid": "media-inline-image-card-icon"
    }, children);
};

});



parcelRegister("i4o81", function(module, exports) {

$parcel$export(module.exports, "default", () => $a406840fbc805bb1$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $kZmsK = parcelRequire("kZmsK");

var $bYRk6 = parcelRequire("bYRk6");



class $a406840fbc805bb1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).PureComponent {
    async componentDidMount() {
        this.mounted = true;
        if (!this.state.MediaInlineCard) try {
            const [mediaClient, cardModule, mediaInlineErrorBoundaryModule] = await Promise.all([
                (parcelRequire("4k6Am")),
                (parcelRequire("da8JS")),
                (parcelRequire("drGyB"))
            ]);
            $a406840fbc805bb1$export$2e2bcd8739ae039.MediaInlineCard = mediaClient.withMediaClient(cardModule.MediaInlineCard);
            $a406840fbc805bb1$export$2e2bcd8739ae039.ErrorBoundary = mediaInlineErrorBoundaryModule.default;
            if (this.mounted) this.setState({
                MediaInlineCard: $a406840fbc805bb1$export$2e2bcd8739ae039.MediaInlineCard,
                ErrorBoundary: $a406840fbc805bb1$export$2e2bcd8739ae039.ErrorBoundary
            });
        } catch (error) {}
    }
    async componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { MediaInlineCard: MediaInlineCard, ErrorBoundary: ErrorBoundary } = this.state;
        const analyticsContext = {
            packageVersion: "platform-pkg",
            packageName: "0.0.0-use.local",
            componentName: 'mediaInlineCard',
            component: 'mediaInlineCard'
        };
        if (!MediaInlineCard || !ErrorBoundary) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kZmsK.MediaInlineCardLoadingView), {
            message: ""
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bYRk6.default), {
            data: analyticsContext,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)(ErrorBoundary, {
                isSelected: this.props.isSelected,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)(MediaInlineCard, {
                    ...this.props
                })
            })
        });
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            MediaInlineCard: $a406840fbc805bb1$export$2e2bcd8739ae039.MediaInlineCard,
            ErrorBoundary: $a406840fbc805bb1$export$2e2bcd8739ae039.ErrorBoundary
        };
    }
}
$a406840fbc805bb1$export$2e2bcd8739ae039.displayName = 'MediaInlineCardLoader';
$a406840fbc805bb1$export$2e2bcd8739ae039.MediaInlineCard = void 0;
$a406840fbc805bb1$export$2e2bcd8739ae039.ErrorBoundary = void 0;

});
parcelRegister("kZmsK", function(module, exports) {

$parcel$export(module.exports, "MediaInlineCardLoadingView", () => $1a4a0b48836516fc$export$4449fcbb2ad61ad1);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $Dmhrr = parcelRequire("Dmhrr");

var $9hlns = parcelRequire("9hlns");

var $d3MnB = parcelRequire("d3MnB");

var $lyeFC = parcelRequire("lyeFC");

var $9HuAe = parcelRequire("9HuAe");
class $1a4a0b48836516fc$export$4449fcbb2ad61ad1 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { message: message, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, innerRef: innerRef, testId: testId = 'media-inline-card-loading-view' } = this.props;
        if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $Dmhrr.Frame), {
            innerRef: innerRef,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected,
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $9HuAe.IconTitleWrapper), {
                children: [
                    message,
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9HuAe.RightIconPositionWrapper), {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lyeFC.SpinnerWrapper), {
                            className: "inline-loading-spinner",
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {
                                size: 14
                            })
                        })
                    })
                ]
            })
        });
        else return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $Dmhrr.Frame), {
            innerRef: innerRef,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d3MnB.IconAndTitleLayout), {
                title: message,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lyeFC.SpinnerWrapper), {
                    className: "inline-loading-spinner",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {
                        size: 14
                    })
                })
            })
        });
    }
}

});
parcelRegister("Dmhrr", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $81345eb3da367d71$export$b89a827e9254211a);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $f32vE = parcelRequire("f32vE");
class $81345eb3da367d71$export$b89a827e9254211a extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { isSelected: isSelected, children: children, onClick: onClick, innerRef: innerRef, testId: testId } = this.props;
        const isInteractive = Boolean(onClick);
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $f32vE.Wrapper), {
            ref: innerRef,
            isSelected: isSelected,
            tabIndex: isInteractive ? 0 : undefined,
            role: isInteractive ? 'button' : undefined,
            onClick: this.handleClick,
            onKeyPress: this.handleKeyPress,
            "data-testid": testId,
            children: children
        });
    }
    constructor(...args){
        super(...args);
        this.handleClick = (event)=>{
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
        this.handleKeyPress = (event)=>{
            if (event.key !== ' ' && event.key !== 'Enter') return;
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
    }
}

});
parcelRegister("f32vE", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $f4d2cc17db8a2086$export$e6dfd72ab29f8598);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $7qw0L = parcelRequire("7qw0L");

var $7ThrQ = parcelRequire("7ThrQ");

var $dh538 = parcelRequire("dh538");
const $f4d2cc17db8a2086$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef((props, ref)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7ThrQ.Wrapper), {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7qw0L.Wrapper), {
        ...props,
        ref: ref
    }));

});
parcelRegister("7qw0L", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $93e87b57966b1260$export$e6dfd72ab29f8598);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $93e87b57966b1260$var$selected = `
  cursor: pointer;
  box-shadow: 0 0 0 1px ${`var(--ds-border-selected, ${(0, $6fnsQ.B300)})`};
  outline: none;
  user-select: none;
  border-color: transparent;
  &, :hover, :focus, :active {
    text-decoration: none;
  }
`;
const $93e87b57966b1260$var$isSelected = ({ isSelected: isSelected })=>{
    if (isSelected) return $93e87b57966b1260$var$selected;
    else return 'user-select: text';
};
const $93e87b57966b1260$export$e6dfd72ab29f8598 = (0, $gwrgp.default)("span", {
    target: "e1t1vqsr0"
})({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
    boxDecorationBreak: 'clone',
    display: 'inline',
    borderRadius: "var(--ds-border-radius, 3px)",
    color: `var(--ds-text, ${(0, $6fnsQ.N900)})`,
    backgroundColor: `var(--ds-background-neutral, ${(0, $6fnsQ.N30A)})`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>$93e87b57966b1260$var$isSelected(props), {
    transition: '0.1s all ease-in-out',
    MozUserSelect: 'none',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $6fnsQ.N40A)})`
    }
});

});

parcelRegister("7ThrQ", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $c18bd19407527c2b$export$e6dfd72ab29f8598);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $c18bd19407527c2b$var$selectedStyles = null;
const $c18bd19407527c2b$var$notSelectedStyles = null;
const $c18bd19407527c2b$var$wrapperStyles = null; /*
                              Media Inline cards should have the following layout:
                              -----------------
                              | icon | title |
                              -----------------
                              The aim is to ensure (1) all children are
                              in line with each other, (2) are vertically
                              centered.
                            */ 
const $c18bd19407527c2b$export$e6dfd72ab29f8598 = ({ isSelected: isSelected, children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": "frame-wrapper",
        ...props,
        className: (0, $35pXk.default)([
            "_2rko1sit _v56415x0 _vwz47vkz _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _16d9qvcn _1e0c1nu9 _syaz1fxt _bfhkm7j4 _1rkwglyw _80omtlke _irr315ej",
            isSelected && "_12ji1r31 _1qu2glyw _12y31o36 _1h6d3acm _80omtlke _16qs666x _uiztglyw _4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1",
            !isSelected && "_uizt1kdv"
        ]),
        children: children
    });

});



parcelRegister("d3MnB", function(module, exports) {

$parcel$export(module.exports, "IconAndTitleLayout", () => $cf4ec8e3d957b355$export$d34be4d513116847);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fp8VN = parcelRequire("fp8VN");

var $3iiat = parcelRequire("3iiat");

var $9HuAe = parcelRequire("9HuAe");

var $8Q3VW = parcelRequire("8Q3VW");
class $cf4ec8e3d957b355$export$d34be4d513116847 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    renderAtlaskitIcon() {
        const { icon: icon, emoji: emoji } = this.props;
        if (emoji) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9HuAe.EmojiWrapper), {
            children: emoji
        });
        if (!icon || typeof icon === 'string') return null;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9HuAe.IconWrapper), {
            children: icon
        });
    }
    renderImageIcon(errored, testId) {
        const { icon: url } = this.props;
        if (!url || typeof url !== 'string') return null;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fp8VN))), {
            src: url,
            loaded: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3iiat.Icon), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "smart-link-icon",
                src: url,
                "data-testid": `${testId}-image`
            }),
            errored: errored
        });
    }
    renderIconPlaceholder(testId) {
        const { defaultIcon: defaultIcon } = this.props;
        if (defaultIcon) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9HuAe.IconWrapper), {
            children: defaultIcon
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9HuAe.IconWrapper), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Q3VW))), {
                color: "currentColor",
                label: "link",
                LEGACY_size: "small",
                testId: `${testId}-default`
            })
        });
    }
    renderIcon(testId) {
        // We render two kinds of icons here:
        // - Image: acquired from either DAC or Teamwork Platform Apps;
        // - Atlaskit Icon: an Atlaskit SVG;
        // Each of these are scaled down to 12x12.
        const icon = this.renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = this.renderIconPlaceholder(testId);
        const image = this.renderImageIcon(placeholder, testId);
        return image || placeholder;
    }
    render() {
        const { children: children, title: title, titleColor: titleColor, testId: testId = 'media-inline-card-icon-and-title' } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $9HuAe.IconTitleWrapper), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: titleColor ? {
                    color: titleColor
                } : undefined,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9HuAe.IconPositionWrapper), {
                        children: children || /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9HuAe.IconEmptyWrapper), {}),
                                this.renderIcon(testId)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                        "data-test-id": "title",
                        children: title
                    })
                ]
            })
        });
    }
}

});
parcelRegister("3iiat", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $85360ec6e10e0eb4$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $85360ec6e10e0eb4$export$a201b065fc2e76a1);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $kDc8H = parcelRequire("kDc8H");

var $kGQvC = parcelRequire("kGQvC");

var $dh538 = parcelRequire("dh538");
const $85360ec6e10e0eb4$export$f04a61298a47a40f = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kGQvC.Icon), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kDc8H.Icon), {
        ...props
    });
const $85360ec6e10e0eb4$export$a201b065fc2e76a1 = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kGQvC.AKIconWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kDc8H.AKIconWrapper), {
        ...props
    });

});
parcelRegister("kDc8H", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $26e5494a2f4757d2$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $26e5494a2f4757d2$export$a201b065fc2e76a1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// TODO: Figure out a more scalable/responsive solution
// for vertical alignment.
// Current rationale: vertically positioned at the top of
// the smart card container (when set to 0). Offset this
// to position it with appropriate whitespace from the top.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gwrgp = parcelRequire("gwrgp");
const $26e5494a2f4757d2$export$f04a61298a47a40f = (0, $gwrgp.default)("img", {
    target: "ebf58rv0"
})({
    name: "ijlt3r",
    styles: "height:14px;width:14px;margin-right:var(--ds-space-050, 4px);border-radius:2px;user-select:none;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"
});
const $26e5494a2f4757d2$export$a201b065fc2e76a1 = (0, $gwrgp.default)("span", {
    target: "ebf58rv1"
})({
    name: "12aho5i",
    styles: "margin-right:var(--ds-space-negative-025, -2px);"
});

});

parcelRegister("kGQvC", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $5112814eaaf490cd$export$f04a61298a47a40f);
$parcel$export(module.exports, "AKIconWrapper", () => $5112814eaaf490cd$export$a201b065fc2e76a1);
/* Icon-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Figure out a more scalable/responsive solution
// for vertical alignment.
// Current rationale: vertically positioned at the top of
// the smart card container (when set to 0). Offset this
// to position it with appropriate whitespace from the top.

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $5112814eaaf490cd$var$iconStyles = null;
const $5112814eaaf490cd$export$f04a61298a47a40f = ({ alt: alt, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("img", {
        alt: alt || '',
        ...props,
        className: (0, $35pXk.default)([
            "_2rkoyh40 _4t3idlk8 _1bsbdlk8 _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
        ])
    }); // Used for 'untrue' icons which claim to be 16x16 but
// are less than that in height/width.
// TODO: Replace this override with proper AtlasKit solution.
const $5112814eaaf490cd$var$akIconWrapperStyles = null;
const $5112814eaaf490cd$export$a201b065fc2e76a1 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...props,
        className: (0, $35pXk.default)([
            "_2hwx1i6y"
        ]),
        children: children
    });

});


parcelRegister("9HuAe", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $40f11cd2f33df153$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $40f11cd2f33df153$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $40f11cd2f33df153$export$c73a53738ef9e3f);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $40f11cd2f33df153$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $40f11cd2f33df153$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $40f11cd2f33df153$export$ddce81e032b0736e);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2LKDa = parcelRequire("2LKDa");

var $fX8We = parcelRequire("fX8We");

var $dh538 = parcelRequire("dh538");
const $40f11cd2f33df153$export$be58b4326e23250f = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fX8We.IconWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LKDa.IconWrapper), {
        ...props
    });
const $40f11cd2f33df153$export$e31a6cc0a4c97f0e = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fX8We.EmojiWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LKDa.EmojiWrapper), {
        ...props
    });
const $40f11cd2f33df153$export$c73a53738ef9e3f = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fX8We.IconTitleWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LKDa.IconTitleWrapper), {
        ...props
    });
const $40f11cd2f33df153$export$75180efdd3f4d9c2 = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fX8We.LozengeWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LKDa.LozengeWrapper), {
        ...props
    });
const $40f11cd2f33df153$export$a16269f205a2f280 = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fX8We.LozengeBlockWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LKDa.LozengeBlockWrapper), {
        ...props
    });
const $40f11cd2f33df153$export$91b164375b8037b5 = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fX8We.RightIconPositionWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LKDa.RightIconPositionWrapper), {
        ...props
    });
const $40f11cd2f33df153$export$7291f9f954790243 = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fX8We.IconPositionWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LKDa.IconPositionWrapper), {
        ...props
    });
const $40f11cd2f33df153$export$ddce81e032b0736e = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fX8We.IconEmptyWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LKDa.IconEmptyWrapper), {
        ...props
    });

});
parcelRegister("2LKDa", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $d460a69b4d3843b5$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $d460a69b4d3843b5$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $d460a69b4d3843b5$export$c73a53738ef9e3f);
$parcel$export(module.exports, "LozengeWrapper", () => $d460a69b4d3843b5$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "LozengeBlockWrapper", () => $d460a69b4d3843b5$export$a16269f205a2f280);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $d460a69b4d3843b5$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $d460a69b4d3843b5$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $d460a69b4d3843b5$export$ddce81e032b0736e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// TODO: remove this override behaviour for @atlaskit/icon-object

var $gwrgp = parcelRequire("gwrgp");
const $d460a69b4d3843b5$export$b993aa7bab57be12 = `
  & > span {
    height: 16px;
    width: 14px;
    position: absolute;
    top: 0;
    left: 0;
    line-height: 14px;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $d460a69b4d3843b5$export$ded9fa9f58c8840e = `
  & > * > span {
    height: 16px;
    width: 14px;
    position: absolute;
    top: 0;
    left: 0;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $d460a69b4d3843b5$export$be58b4326e23250f = (0, $gwrgp.default)("span", {
    target: "ec5pts50"
})("user-select:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$d460a69b4d3843b5$export$ded9fa9f58c8840e, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$d460a69b4d3843b5$export$b993aa7bab57be12);
const $d460a69b4d3843b5$export$e31a6cc0a4c97f0e = (0, $gwrgp.default)("span", {
    target: "ec5pts51"
})("display:inline-block;margin-right:var(--ds-space-025, 2px);user-select:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$d460a69b4d3843b5$export$ded9fa9f58c8840e, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$d460a69b4d3843b5$export$b993aa7bab57be12);
const $d460a69b4d3843b5$export$c73a53738ef9e3f = (0, $gwrgp.default)("span", {
    target: "ec5pts52"
})({
    name: "1p7ax5",
    styles: "white-space:pre-wrap;word-break:break-all;"
});
const $d460a69b4d3843b5$export$75180efdd3f4d9c2 = (0, $gwrgp.default)("span", {
    target: "ec5pts53"
})({
    display: 'inline-block',
    verticalAlign: '1px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        marginLeft: "var(--ds-space-050, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"} 0`
    }
});
const $d460a69b4d3843b5$export$a16269f205a2f280 = (0, $gwrgp.default)("span", {
    target: "ec5pts54"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        marginLeft: "var(--ds-space-050, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"} 0`
    }
});
const $d460a69b4d3843b5$export$91b164375b8037b5 = (0, $gwrgp.default)("span", {
    target: "ec5pts55"
})({
    name: "15325vn",
    styles: "margin-left:var(--ds-space-025, 2px);margin-right:var(--ds-space-050, 4px);position:relative;display:inline-block;"
});
const $d460a69b4d3843b5$export$7291f9f954790243 = (0, $gwrgp.default)("span", {
    target: "ec5pts56"
})({
    name: "1lcr4h8",
    styles: "margin-right:var(--ds-space-050, 4px);position:relative;display:inline-block;"
});
const $d460a69b4d3843b5$export$ddce81e032b0736e = (0, $gwrgp.default)("span", {
    target: "ec5pts57"
})({
    name: "klch0j",
    styles: "width:14px;height:100%;display:inline-block;opacity:0;"
});

});

parcelRegister("fX8We", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $fd9b070c354e8c1f$export$be58b4326e23250f);
$parcel$export(module.exports, "EmojiWrapper", () => $fd9b070c354e8c1f$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "IconTitleWrapper", () => $fd9b070c354e8c1f$export$c73a53738ef9e3f);
$parcel$export(module.exports, "LozengeWrapper", () => $fd9b070c354e8c1f$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "LozengeBlockWrapper", () => $fd9b070c354e8c1f$export$a16269f205a2f280);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $fd9b070c354e8c1f$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $fd9b070c354e8c1f$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $fd9b070c354e8c1f$export$ddce81e032b0736e);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// TODO: remove this override behaviour for @atlaskit/icon-object

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $fd9b070c354e8c1f$var$iconObjectOverrideStyles = null; // TODO: remove this override behaviour for @atlaskit/icon
const $fd9b070c354e8c1f$var$iconOverrideStyles = null;
const $fd9b070c354e8c1f$var$iconWrapperStyles = null; // Wraps all icons represented in Inline Links. Icons have three sources/types:
const $fd9b070c354e8c1f$export$be58b4326e23250f = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...props,
        className: (0, $35pXk.default)([
            "_uiztglyw",
            "_1f027vkz _nbgxdlk8 _4d7tstnw _o5fvidpf _3g5ridpf _z6uadlk8 _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            "_17047vkz _iibfdlk8 _lacastnw _1kd9idpf _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe"
        ]),
        children: children
    });
const $fd9b070c354e8c1f$var$emojiWrapperStyles = null; // Wraps all emoji in Inline Links similar to icon
const $fd9b070c354e8c1f$export$e31a6cc0a4c97f0e = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...props,
        className: (0, $35pXk.default)([
            "_1e0c1o8l _2hwxv77o _uiztglyw",
            "_1f027vkz _nbgxdlk8 _4d7tstnw _o5fvidpf _3g5ridpf _z6uadlk8 _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            "_17047vkz _iibfdlk8 _lacastnw _1kd9idpf _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe"
        ]),
        children: children
    });
const $fd9b070c354e8c1f$var$iconTitleWrapperStyles = null; // The main 'wrapping' element, title of the content.
const $fd9b070c354e8c1f$export$c73a53738ef9e3f = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...props,
        className: (0, $35pXk.default)([
            "_o5721jtm _1nmz9jpi"
        ]),
        children: children
    });
const $fd9b070c354e8c1f$var$lozengeWrapperStyles = null; // TODO: Replace overrides with proper AtlasKit solution.
const $fd9b070c354e8c1f$export$75180efdd3f4d9c2 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...props,
        className: (0, $35pXk.default)([
            "_1e0c1o8l _s7n4t94y _1msp1b66 _1at8v77o _hjaqidpf _1cjov77o _1yg6idpf"
        ]),
        children: children
    });
const $fd9b070c354e8c1f$var$lozengeBlockWrapperStyles = null; // TODO: Replace overrides with proper AtlasKit solution.
const $fd9b070c354e8c1f$export$a16269f205a2f280 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...props,
        className: (0, $35pXk.default)([
            "_1msp1b66 _1at8v77o _hjaqidpf _1cjov77o _1yg6idpf"
        ]),
        children: children
    });
const $fd9b070c354e8c1f$var$rightIconPositionWrapperStyles = null;
const $fd9b070c354e8c1f$export$91b164375b8037b5 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...props,
        className: (0, $35pXk.default)([
            "_18u0v77o _2hwx1b66 _kqswh2mm _1e0c1o8l"
        ]),
        children: children
    });
const $fd9b070c354e8c1f$var$iconPositionWrapperStyles = null; // The following components are used to absolutely position icons in the vertical center.
const $fd9b070c354e8c1f$export$7291f9f954790243 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...props,
        className: (0, $35pXk.default)([
            "_2hwx1b66 _kqswh2mm _1e0c1o8l"
        ]),
        children: children
    });
const $fd9b070c354e8c1f$var$iconEmptyWrapperStyles = null;
const $fd9b070c354e8c1f$export$ddce81e032b0736e = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...props,
        className: (0, $35pXk.default)([
            "_1bsbdlk8 _4t3i1osq _1e0c1o8l _tzy4idpf"
        ]),
        children: children
    });

});



parcelRegister("lyeFC", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $d812b1a99afbef93$export$52b4dfd89a6b3a1b);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $eeDwq = parcelRequire("eeDwq");

var $3VTkZ = parcelRequire("3VTkZ");

var $dh538 = parcelRequire("dh538");
const $d812b1a99afbef93$export$52b4dfd89a6b3a1b = (props)=>(0, $dh538.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3VTkZ.SpinnerWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eeDwq.SpinnerWrapper), {
        ...props
    });

});
parcelRegister("eeDwq", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $742f0deb19d1e22c$export$52b4dfd89a6b3a1b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2LKDa = parcelRequire("2LKDa");

var $gwrgp = parcelRequire("gwrgp");
const $742f0deb19d1e22c$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $gwrgp.default)((0, $2LKDa.IconTitleWrapper), {
    target: "e9a5khx0"
})({
    name: "wbojq2",
    styles: "vertical-align:baseline;margin-left:var(--ds-space-025, 2px);"
});

});

parcelRegister("3VTkZ", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $8f39e15e200c8aa2$export$52b4dfd89a6b3a1b);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $8f39e15e200c8aa2$var$spinnerWrapperStyles = null;
const $8f39e15e200c8aa2$export$52b4dfd89a6b3a1b = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...props,
        className: (0, $35pXk.default)([
            "_o5721jtm _1nmz9jpi _s7n418uv _18u0v77o"
        ]),
        children: children
    });

});



parcelRegister("4k6Am", function(module, exports) {

let $325e2367e16d5642$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $325e2367e16d5642$var$load("aZinD"),
    $325e2367e16d5642$var$load("6aruy")
]).then(()=>parcelRequire('9VKkC'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});



parcelRegister("da8JS", function(module, exports) {

let $9952fcee55ef0aad$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $9952fcee55ef0aad$var$load("9ldIR"),
    $9952fcee55ef0aad$var$load("dil5i"),
    $9952fcee55ef0aad$var$load("2fk6g"),
    $9952fcee55ef0aad$var$load("hPalR"),
    $9952fcee55ef0aad$var$load("8059b"),
    $9952fcee55ef0aad$var$load("jDjSj"),
    $9952fcee55ef0aad$var$load("4M7W5")
]).then(()=>parcelRequire('akEZB'));

});

parcelRegister("drGyB", function(module, exports) {

let $9c9eceeb3bc809c1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9c9eceeb3bc809c1$var$load("iP5Bv").then(()=>parcelRequire('lysJr'));

});



//# sourceMappingURL=mediaInline.e226fc2c.js.map
